import React, { useState, useEffect } from 'react';
import { Select, Row, Col, Card, Table, Spin } from 'antd';

const { Option } = Select;

const MonthYearSelector = ({ onChange }) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // JavaScript: meses de 0 a 11
  const currentYear = currentDate.getFullYear();

  const months = [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' },
  ];

  const years = [];
  const startYear = 2024;
  for (let year = startYear; year <= currentYear + 1; year++) {
    years.push(year);
  }

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    onChange && onChange({ month: value, year: selectedYear });
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
    onChange && onChange({ month: selectedMonth, year: value });
  };

  return (
    <Row gutter={16} style={{ marginBottom: 20 }}>
      <Col>
        <Select
          value={selectedMonth}
          onChange={handleMonthChange}
          style={{ width: 150 }}
          placeholder="Mês"
        >
          {months.map((month) => (
            <Option key={month.value} value={month.value}>
              {month.label}
            </Option>
          ))}
        </Select>
      </Col>
      <Col>
        <Select
          value={selectedYear}
          onChange={handleYearChange}
          style={{ width: 120 }}
          placeholder="Ano"
        >
          {years.map((year) => (
            <Option key={year} value={year}>
              {year}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
  );
};

export default MonthYearSelector;
